import { AfterViewInit, Directive, ElementRef, OnDestroy, output, inject } from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceInput]',
  standalone: true,
})
export class DebounceInputDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef);

  public readonly debouncedInput = output<string>();

  inputEvent$!: Observable<any>;
  inputEventSubscription!: Subscription;

  ngAfterViewInit(): void {
    this.inputEvent$ = fromEvent(this.el?.nativeElement, 'input').pipe(
      map((event: any) => (event.target as HTMLInputElement).value), //map((event: Event) => (event.target as HTMLInputElement).value),
      debounceTime(1000),
      distinctUntilChanged(),
      tap(text => this.debouncedInput.emit(text)),
    );

    this.inputEventSubscription = this.inputEvent$.subscribe();
  }

  ngOnDestroy(): void {
    this.inputEventSubscription.unsubscribe();
  }
}
